// extracted by mini-css-extract-plugin
export var footer = "_rc-0";
export var inherit = "_rc-1";
export var input = "_rc-2";
export var modalContent = "_rc-3";
export var quillEditor = "_rc-4";
export var subtitle = "_rc-5";